import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { Button, Intent } from "@blueprintjs/core";
import Toast from 'helpers/toaster';
import FormDrawer from 'components/FormDrawer';
import { FormSection, FieldError } from 'components/FormBits';

@inject('formStore') @observer
class AddFormModal extends Component {
  // The dialog's own field, blank on every open.
  @observable name = '';

  @observable errors = {};

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.name = '';
      this.errors = {};
    }
  }

  nameInput = React.createRef();

  handleOpened() {
    this.errors = {};
    if (this.nameInput.current) this.nameInput.current.focus();
  }

  validate() {
    const errors = {};
    if (!this.name.trim()) {
      errors.name = 'Give the form a name, e.g. "Furnace inspection checklist".';
    }
    this.errors = errors;
    return Object.keys(errors).length === 0;
  }

  createForm(event) {
    if (event && event.preventDefault) event.preventDefault();
    if (this.props.formStore.form.isLoading) return;
    if (!this.validate()) {
      if (this.nameInput.current) this.nameInput.current.focus();
      return;
    }
    this.props.formStore.createForm({ name: this.name })
      .then(this.onSuccessfulCreateForm.bind(this))
      .catch(this.onFailCreateForm.bind(this))
  }

  onSuccessfulCreateForm(response) {
    Toast.show({ icon: 'thumbs-up', message: 'Form saved successfully. Lets add some contents to form.', intent: Intent.SUCCESS })
    this.props.onSuccess()
  }

  onFailCreateForm(error) {
    console.log("Error in create form: " + error)
  }

  handleCloseFormDailog() {
    this.props.onClose()
  }

  render() {
    let { isLoading } = this.props.formStore.form;
    const busy = !!isLoading;
    const { errors } = this;
    return(
      <FormDrawer
        title="New form"
        icon="form"
        isOpen={this.props.isOpen}
        onOpened={this.handleOpened.bind(this)}
        onClose={this.handleCloseFormDailog.bind(this)}
        busy={busy}
        footer={
          <>
            <Button text="Cancel" onClick={this.handleCloseFormDailog.bind(this)} disabled={busy} />
            <Button
              intent={Intent.PRIMARY}
              icon="arrow-right"
              text="Create form and add questions"
              loading={busy}
              onClick={this.createForm.bind(this)}
            />
          </>
        }
      >
        <form onSubmit={this.createForm.bind(this)} noValidate>
          <FormSection
            title="Name the form"
            hint="A checklist or questionnaire your techs fill in on a job. You'll add the questions next."
          >
            <div className={`bp3-form-group${errors.name ? ' has-error' : ''}`}>
              <label className="fb-label" htmlFor="form-name">
                Form name<span className="fb-required" aria-hidden="true"> *</span>
              </label>
              <input
                id="form-name"
                ref={this.nameInput}
                type='text'
                className='bp3-input bp3-fill'
                placeholder='e.g. Furnace inspection checklist'
                autoComplete="off"
                aria-required="true"
                aria-invalid={errors.name ? true : undefined}
                aria-describedby={errors.name ? 'form-name-error' : undefined}
                value={this.name}
                onChange={(event) => {
                  this.name = event.target.value;
                  if (this.errors.name) this.errors = {};
                } }
              />
              <FieldError id="form-name-error">{errors.name}</FieldError>
            </div>
          </FormSection>
        </form>
      </FormDrawer>
    )
  }

};

export default AddFormModal;
